import React from "react";
import styled from "styled-components";

const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
`


export const MyDelegation = () => {
    return(
        <Container>

        </Container>
    )
}